// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 123 ? "icons" : chunkId) + "-" + {"123":"9883cb","307":"a53005","328":"92a488","430":"0c8fa1","527":"762d57"}[chunkId] + ".js";
};